import { PropsWithChildren } from 'react'

import styles from './Headline.module.scss'

interface HeadlineProps extends PropsWithChildren {
  className?: string
}

const Headline = ({ children, className }: HeadlineProps) => {
  return (
    <h1 className={`${styles.headline} ${className ?? ''}`} data-testid="headline">
      {children}
    </h1>
  )
}

export default Headline
